import React from 'react';
import { useFeatureFlags } from 'components/FeatureFlags';
import {
  useIsRbacEnabled,
  useUserAbilitiesContext,
} from 'context/user/UserContext';
import { routes } from './routes';
import { getTabIcon } from './NavigationTabs';
import NavigationTab from './NavigationTab';

export default function FallbackNavigationTabs({
  isLeftRailOpen,
}: {
  isLeftRailOpen: boolean;
}) {
  const ability = useUserAbilitiesContext();
  const isRbacEnabled = useIsRbacEnabled();

  const { isFeatureEnabled } = useFeatureFlags();

  const mainNavigationTabs = routes.filter(item => {
    const { featureFlag, ability: routeAbility } = item;
    if (featureFlag && !isFeatureEnabled(featureFlag)) {
      return false;
    }
    if (isRbacEnabled && routeAbility) {
      return ability.can(routeAbility.action, routeAbility.subject);
    }
    return true;
  });

  return (
    <>
      {mainNavigationTabs.map(tab => (
        <NavigationTab
          key={tab.label}
          label={tab.label}
          href={tab.route}
          Icon={getTabIcon(tab.iconType)}
          isLeftRailOpen={isLeftRailOpen}
          additionalRoutes={tab.additionalRoutes}
        />
      ))}
    </>
  );
}
